<div class="checkbox-wrapper  {{ customClass }}" [class.disabled]="disabled" [class.error]="!!error">
  @if (label && labelPosition === 'top') {
  <!-- Label arriba -->
  <label class="mb-2 text-2xl font-medium text-red-300" [class.text-gray-400]="disabled">{{ label }}</label>
  }

  <div class="flex items-center gap-3">
    <label
      [for]="idFinal"
      class="flex items-center gap-3 w-full m-0"
       [ngClass]="{
         'cursor-pointer': !parentController,
         'pointer-events-none': parentController
       }"
      [class.text-gray-400]="disabled"
      style="margin-bottom: 0;"
    >
      <!-- Checkbox siempre primero cuando labelPosition es 'left' -->
      <div class="relative flex-shrink-0"
        [ngClass]="{
          'w-4 h-4': size === 'small',
          'w-6 h-6': size === 'medium',
          'w-10 h-10': size === 'large'
        }">
        <input
          type="checkbox"
          [ngClass]="getCheckboxClasses()"
          [checked]="checked"
          [disabled]="disabled || readonly"
          (change)="onCheckboxChange($event)"
          [id]="idFinal"
          [name]="name || idFinal"
        />
        <svg *ngIf="checked" class="pointer-events-none absolute inset-0 m-auto text-white"
          [ngClass]="{
            'w-3 h-3': size === 'small',
            'w-4 h-4': size === 'medium',
            'w-8 h-8': size === 'large'
          }"
          fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      
      @if (labelPosition === 'left') {
      <span class="text-sm text-left select-none flex-1 min-w-0">
        <ng-content select="[label-left]"></ng-content>
      </span>
      }
      
      @if (labelPosition === 'right') {
      <span class="text-sm text-text-secondary text-left select-none">
        <ng-content></ng-content>
      </span>
      }
    </label>
  </div>

  @if (error) {
  <div class="flex items-center mt-1 ml-1 pl-6 ">
    <i class="fa-solid fa-triangle-exclamation text-error-check mr-1 text-x"></i>
    <span class="text-error-check text-x font-medium">{{ error }}</span>
  </div>
  }
</div>